// the SwapKing Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = process.env.REACT_APP_TOKEN_LIST_URL ?? ''

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]

export const DEFAULT_KCHART_URL = process.env.REACT_APP_KCHART_URL ?? ''